<template lang="pug">
  div(:class="{'nav-open': $sidebar.show}")
    Notifications
    RouterView
</template>

<script>
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/scss/regular.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/sass/paper-dashboard.scss'
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('auth', ['isAuth'])
  },
  async created () {
    if (this.isAuth) {
      try {
        await this.check()
      } catch (error) {
        await this.logout()
      }
    }
  },
  methods: {
    ...mapActions('auth', ['check', 'logout'])
  }
}
</script>
